/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Italics_LabelInputs */

const en_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial Italics`)
};

const fr_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italique partiel`)
};

const de_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilweise Kursivschrift`)
};

const it_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corsivo parziale`)
};

const ru_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частичный курсив`)
};

const es_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cursiva parcial`)
};

const zh_cn2_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分斜体`)
};

const ja_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分イタリック体`)
};

const hi_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आंशिक इटैलिक`)
};

const pt_pt2_style_guide_manager_partial_italics_label = /** @type {(inputs: Style_Guide_Manager_Partial_Italics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itálico parcial`)
};

/**
* | output |
* | --- |
* | "Partial Italics" |
*
* @param {Style_Guide_Manager_Partial_Italics_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_italics_label = /** @type {((inputs?: Style_Guide_Manager_Partial_Italics_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Italics_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_partial_italics_label(inputs)
	if (locale === "de") return de_style_guide_manager_partial_italics_label(inputs)
	if (locale === "it") return it_style_guide_manager_partial_italics_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_partial_italics_label(inputs)
	if (locale === "es") return es_style_guide_manager_partial_italics_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_partial_italics_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_partial_italics_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_partial_italics_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_partial_italics_label(inputs)
	return en_style_guide_manager_partial_italics_label(inputs)
});